var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management-modal", {
    ref: "modal",
    attrs: { element: _vm.opportunity },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              {
                class: _vm.hasErrorClass(_vm.$v.opportunity.name, "form-group"),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Name"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.opportunity.name.$model,
                      expression: "$v.opportunity.name.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "name",
                    type: "text",
                    placeholder: "Guest speaking",
                  },
                  domProps: { value: _vm.$v.opportunity.name.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.opportunity.name,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: { field: _vm.$v.opportunity.name, label: "Name" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.opportunity.appearance_type,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Appearance Type"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "selectize selectize-single form-control",
                  attrs: {
                    name: "appearance_type",
                    options: _vm.appearanceTypeOptions,
                    "disable-delete": true,
                  },
                  model: {
                    value: _vm.$v.opportunity.appearance_type.$model,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.$v.opportunity.appearance_type,
                        "$model",
                        $$v
                      )
                    },
                    expression: "$v.opportunity.appearance_type.$model",
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.opportunity.appearance_type,
                    label: "Appearance Type",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.opportunity.field_set,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Field Set"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "selectize selectize-single form-control",
                  attrs: {
                    name: "field_set",
                    options: _vm.fieldSetOptions,
                    "disable-delete": true,
                  },
                  model: {
                    value: _vm.$v.opportunity.field_set.$model,
                    callback: function ($$v) {
                      _vm.$set(_vm.$v.opportunity.field_set, "$model", $$v)
                    },
                    expression: "$v.opportunity.field_set.$model",
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.opportunity.field_set,
                    label: "Field Set",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.opportunity.optional_fields,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Optional Fields"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "selectize selectize-multiple form-control",
                  attrs: {
                    multiple: "",
                    placeholder: "None",
                    name: "optional_fields",
                    options: _vm.optionalFieldOptions,
                    "disable-delete": true,
                  },
                  model: {
                    value: _vm.$v.opportunity.optional_fields.$model,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.$v.opportunity.optional_fields,
                        "$model",
                        $$v
                      )
                    },
                    expression: "$v.opportunity.optional_fields.$model",
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.opportunity.optional_fields,
                    label: "Optional Fields",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.opportunity.category_id,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Category"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "selectize selectize-single form-control",
                  attrs: {
                    name: "category",
                    options: _vm.categoryOptions,
                    "disable-delete": true,
                  },
                  model: {
                    value: _vm.$v.opportunity.category_id.$model,
                    callback: function ($$v) {
                      _vm.$set(_vm.$v.opportunity.category_id, "$model", $$v)
                    },
                    expression: "$v.opportunity.category_id.$model",
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.opportunity.category_id,
                    label: "Category",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.selectedCategory &&
            _vm.selectedCategory.currency === "points" &&
            _vm.$opportunityPointsModuleEnabled
              ? _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(
                      _vm.$v.opportunity.points,
                      "form-group"
                    ),
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("* Points"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("span", { staticClass: "input-group-addon" }, [
                        _vm._v(_vm._s(_vm.moneySymbol)),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.opportunity.points.$model,
                            expression: "$v.opportunity.points.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          name: "name",
                          type: "text",
                          placeholder: "Points",
                        },
                        domProps: { value: _vm.$v.opportunity.points.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.opportunity.points,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("vuelidate-help", {
                      attrs: {
                        field: _vm.$v.opportunity.points,
                        label: "Points",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.budgetRequired || !_vm.selectedCategory) &&
            _vm.$opportunityBudgetsModuleEnabled
              ? _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(
                      _vm.$v.opportunity.budget,
                      "form-group"
                    ),
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm.budgetRequired
                        ? _c("span", [_vm._v("* ")])
                        : _vm._e(),
                      _vm._v("Value"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("span", { staticClass: "input-group-addon" }, [
                        _vm._v(_vm._s(_vm.moneySymbol)),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.opportunity.budget.$model,
                            expression: "$v.opportunity.budget.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "name", type: "text", placeholder: "1" },
                        domProps: { value: _vm.$v.opportunity.budget.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.opportunity.budget,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("vuelidate-help", {
                      attrs: {
                        field: _vm.$v.opportunity.budget,
                        label: "Value",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-lg btn-primary pull-right",
                attrs: {
                  click: _vm.saveOpportunity,
                  type: "button",
                  "data-dismiss": "modal",
                },
              },
              [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Save")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }